import { fractionInput } from '@utils/component-framework';
import { NoSSR } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useTaskContext } from '../../context.js';
import { useInputState } from '../../hook.use-input-state.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { TextInput } from './atom.text-input.js';
import { shouldHaveGroup, stateBox, container, fraction, readonlyFractionValue } from './input.fraction.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function WriteAnswersFractionInput(props) {
  const context = useTaskContext();
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => fractionInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = (evt, target) => {
    update(props.taskEntryKey, props.node.id, {
      type: "fraction",
      denominator: "",
      number: "",
      numerator: "",
      ...inputEntry,
      [target]: evt.currentTarget.value ?? ""
    });
  };
  const state = useInputState(props.node, inputEntry);
  if (state !== "input") {
    const correctAnswer = fractionInput.getCorrectOption(props.node, inputEntry);
    return /*#__PURE__*/jsxs("span", {
      className: shouldHaveGroup,
      children: [/*#__PURE__*/jsx(StateBox, {
        state: state,
        className: stateBox,
        children: /*#__PURE__*/jsxs("div", {
          className: container,
          children: [!props.node.styling.hideNumber && inputEntry?.number, (inputEntry?.numerator || inputEntry?.denominator) && /*#__PURE__*/jsxs("div", {
            className: fraction,
            children: [/*#__PURE__*/jsx("span", {
              className: readonlyFractionValue,
              children: inputEntry?.numerator
            }), /*#__PURE__*/jsx("span", {
              className: readonlyFractionValue,
              children: inputEntry?.denominator
            })]
          })]
        })
      }), state === "incorrect" && /*#__PURE__*/jsx(StateBox, {
        state: "should-have",
        className: stateBox,
        children: /*#__PURE__*/jsxs("div", {
          className: container,
          children: [!props.node.styling.hideNumber && correctAnswer?.number, (correctAnswer?.numerator || correctAnswer?.denominator) && /*#__PURE__*/jsxs("div", {
            className: fraction,
            children: [/*#__PURE__*/jsx("span", {
              className: readonlyFractionValue,
              children: correctAnswer?.numerator
            }), /*#__PURE__*/jsx("span", {
              className: readonlyFractionValue,
              children: correctAnswer?.denominator
            })]
          })]
        })
      })]
    });
  } else {
    return /*#__PURE__*/jsx(NoSSR, {
      children: /*#__PURE__*/jsxs("div", {
        className: container,
        children: [!props.node.styling.hideNumber && /*#__PURE__*/jsx(TextInput, {
          value: inputEntry?.number,
          state: state,
          enterKeyHint: props.isLastInput ? "done" : "next",
          readOnly: context === "facit" || context === "readonly",
          onChange: evt => onChange(evt, "number"),
          inputMode: "numeric",
          height: "small"
        }), /*#__PURE__*/jsxs("div", {
          className: fraction,
          children: [/*#__PURE__*/jsx(TextInput, {
            value: inputEntry?.numerator,
            state: state,
            enterKeyHint: props.isLastInput ? "done" : "next",
            readOnly: context === "facit" || context === "readonly",
            onChange: evt => onChange(evt, "numerator"),
            inputMode: "numeric",
            height: "small"
          }), /*#__PURE__*/jsx(TextInput, {
            value: inputEntry?.denominator,
            state: state,
            enterKeyHint: props.isLastInput ? "done" : "next",
            readOnly: context === "facit" || context === "readonly",
            onChange: evt => onChange(evt, "denominator"),
            inputMode: "numeric",
            height: "small"
          })]
        })]
      })
    });
  }
}

export { WriteAnswersFractionInput };
//# sourceMappingURL=input.fraction.js.map
